<template>
  <div class="user container">
    <div class="info">
      <h1 class="title">用户中心</h1>
      <p class="label">用户名</p>
      <p class="value">{{ userInfo.username }}</p>
      <p class="label">(用户ID：{{ userInfo.id }})</p>
    </div>
    <div class="services">
      <h1 class="title">我的服务</h1>
      <div class="inner">
        <div class="service" v-for="service in services" :key="service.name">
          <h4>{{ service.name }}</h4>
          <div class="body">
            <!-- 未开通 -->
            <div v-if="service.status == 0">
              <div class="no-service">
                <img src="../assets/img/notopen.png" alt="" />

                <p>当前未开通{{ service.name }}</p>
                <a
                  class="desc"
                  href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
                  target="_blank"
                  >如需开通请联系商务</a
                >
              </div>
              <!-- 过期 -->
              <div class="no-service" v-if="service.status == 2">
                <img src="../assets/img/expired.png" alt="" />

                <p>服务已过期</p>
                <a
                  class="desc"
                  href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
                  target="_blank"
                  >继续使用请联系商务</a
                >
              </div>
            </div>

            <table v-else cellpadding="0" cellspacing="0">
              <tbody>
                <tr class="header">
                  <td>服务</td>
                  <td>过期时间</td>
                  <td v-if="service.services[0].dosage">今日请求次数</td>
                </tr>
                <tr
                  class="content"
                  v-for="(item, index) in service.services"
                  :key="index"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.expirydate }}</td>
                  <td v-if="item.dosage">
                    {{ item.dosage.dayNum }}/{{ item.dosage.dayLimit }}次
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <a
        class="btn"
        href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
        target="_blank"
        >联系商务</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "User",
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      localStorage.setItem("session", session);
      localStorage.setItem("isLogin", "1");
    }
    this.session = localStorage.getItem("session");
    let isLogin = localStorage.getItem("isLogin");
    this.isLogin = isLogin;
    this.queryUserINfo();
  },
  data() {
    return {
      userInfo: {},
      services: [],
    };
  },
  methods: {
    queryUserINfo() {
      if (this.isLogin) {
        this.$http.get("/fireeye/account/details").then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.userInfo = data.data;
            this.$root.status = this.userInfo.status;
            window.localStorage.setItem(
              "status",
              this.userInfo.status.toString()
            );
            this.services = data.data.serviceList;
          } else {
            console.log("获取用户信息失败");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.user {
  .title {
    font-size: 36px;
    font-family: GlowSansSC-Normal-Heavy, GlowSansSC-Normal;
    font-weight: 800;
    color: #ff9459;
    line-height: 52px;
  }
  .info {
    background: linear-gradient(
      180deg,
      rgba(183, 183, 183, 0.2) 0%,
      rgba(255, 255, 255, 0.1) 100%
    );
    box-shadow: 0px 14px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    border: 2px solid;
    text-align: center;
    margin-top: 40px;

    .label {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
    }
    .value {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff9459;
      line-height: 50px;
    }
  }
  .services {
    background: linear-gradient(
      180deg,
      rgba(183, 183, 183, 0.2) 0%,
      rgba(255, 255, 255, 0.1) 100%
    );
    box-shadow: 0px 14px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    border: 2px solid;
    text-align: center;
    margin-top: 40px;
    padding: 24px;

    .inner {
      display: flex;
      column-gap: 20px;

      .service {
        width: 50%;
        height: 100%;

        h4 {
          position: relative;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
        }
        .body {
          background-color: #fff;

          .no-service {
            padding: 40px;
            .icon {
            }
            .desc {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
              display: block;
              text-align: center;
              margin-top: 20px;
              text-decoration: none;
            }
          }
          table {
            width: 100%;
            td {
              padding: 20px 0;
            }
            .header {
              background: #fd975e;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 25px;
            }
            .content {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }
        }
      }
    }
    .btn {
      display: block;
      width: 178px;
      margin: 20px auto 0;
      text-decoration: none;
      padding: 10px 0;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff9459;
      line-height: 33px;
      border: 1px solid rgba(255, 148, 89, 0.3);
    }
  }
}
</style>